import { errorNotification } from "Components/MyNotification";
import ProjectApi from "./ProjectApi";

export const getAllMaterialsForProjectToSelect = async (
  search,
  projectId = "",
) => {
  try {
    const result = await ProjectApi.findAllMaterialsForProject(
      1,
      search,
      projectId,
    );

    // {
    //   id:'',
    //   restCount:'',
    //   dateArrived:'',
    //   nomenclature:'',
    //   unit:'',
    //   workTypeTied
    // }

    if (result.status === "success") {
      if (projectId) {
        return result.dto.map((item) => ({
          label: `${item.dateArrived} ${item.nomenclature}. Залишок: ${item.restCount} ${item.unit}`,
          value:
            JSON.stringify({
              id: item.id,
              value: 0,
              nomenclature: item.nomenclature,
              unit: item.unit,
              dateArrived: item.dateArrived,
              restCount: item.restCount,
              restCountAfterChanges: item.restCount,
              workTypeTied: item["workTypeTied.id"]
                ? {
                    allowedWorkTypeId: item["workTypeTied.id"],
                    title: item["workTypeTied.title"],
                    code: item["workTypeTied.code"],
                    code_norm: item["workTypeTied.code_norm"],
                    value: 0,
                    comment: "",
                    unit: item["workTypeTied.unit"],
                    connectionWithMaterial:
                      item["workTypeTied.connectionWithMaterial"],
                  }
                : null,
            }) +
            "___" +
            item.id,
        }));
      }
    }
    if (result.status === "fail") {
      errorNotification(result.message);
      return [];
    }
    return [];
  } catch (err) {
    errorNotification(err?.message);
    return [];
  }
};
